import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import { EzTuxLowInventoryReport } from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';

type LowInventoryResult = {
  success: boolean;
  data: EzTuxLowInventoryReport | undefined;
};

@Injectable({
  providedIn: 'root',
})
export class WholesaleLowInventoryService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly lowInventoryApiUrl =
    this.environment.low_inventory_api_server_url;

  public getLowInventory(): Observable<LowInventoryResult> {
    return this.http
      .get<EzTuxLowInventoryReport>(this.lowInventoryApiUrl, {
        ...requireAppCheck,
      })
      .pipe(
        map((data) => ({
          success: true,
          data,
        })),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: undefined });
        }),
      );
  }
}
